import React, { Component } from 'react';
import isContractInitialized from '../../utils/ContractInitializationState';
import LoadingAnimation from '../Components/LoadingAnimation';
import { TX_ERROR_TRANSFER_COINS, TX_TRANSFER_COINS } from '../../utils/TransactionTypes';
import {
  addTransactionInProgress,
  transactionErrorHandler,
  transactionReceiptHandler
} from '../../utils/TransactionStateHelper';

class TransferCoins extends Component {
  constructor (props) {
    super(props);

    this.state = {
      currentAccount: null,
      toAddress: '',
      coins: '',
      hasCoinsToTransfer: false,
      contractLoaded: false
    };

    this.storageUnsubscribe = null;
    this.handleTransfer = this.handleTransfer.bind(this);
    this.handleToAddressChange = this.handleToAddressChange.bind(this);
    this.handleCoinsChange = this.handleCoinsChange.bind(this);
  }

  componentDidMount () {
    this.isContractLoaded();
    this.storageUnsubscribe = Storage.subscribe(() => this.isContractLoaded());
  }

  isContractLoaded () {
    isContractInitialized() && !this.state.contractLoaded && this.init();
  }

  componentWillUnmount () {
    this.storageUnsubscribeHandler();
  }

  storageUnsubscribeHandler () {
    this.storageUnsubscribe && this.storageUnsubscribe();
  }

  init () {
    this.storageUnsubscribeHandler();
    this.setState({
      contractLoaded: true
    });

    this.setHasCoinsToTransfer();
    this.storageUnsubscribe = Storage.subscribe(() => this.setHasCoinsToTransfer());
  }

  setHasCoinsToTransfer () {
    this.setState({
      hasCoinsToTransfer: Storage.getState().account.asyncCoinBalance > 0
    });
  }

  handleToAddressChange (event) {
    this.setState({
      toAddress: event.target.value
    });
  }

  handleCoinsChange (event) {
    this.setState({
      coins: +event.target.value || ''
    });
  }

  handleTransfer (event) {
    // We don't want normal page submit
    event.preventDefault();

    if (this.state.toAddress === '') {
      window.notifications.showError('Receiving address is empty.');

      return;
    }

    if (this.state.coins <= 0) {
      window.notifications.showError('Coins must be over 0.');

      return;
    }

    window.contract
      .methods
      .transfer(this.state.toAddress, this.state.coins)
      .send({from: Storage.getState().account.currentAccount, gasPrice: 0})
      .on('transactionHash', (hash) => addTransactionInProgress(hash, TX_TRANSFER_COINS, TX_ERROR_TRANSFER_COINS))
      .on('receipt', (receipt) => transactionReceiptHandler(receipt, () => {
        this.setState({
          toAddress: '',
          coins: ''
        });

        window.notifications.showSuccess('Coins were successfully sent.');
      }))
      .on('error', (err, receipt) => transactionErrorHandler(err, receipt));
  }

  renderForm () {
    if (!this.state.contractLoaded) {
      return (<LoadingAnimation/>);
    }

    if (!this.state.hasCoinsToTransfer) {
      return (<div>You don't have enough coins to transfer.</div>);
    }

    return (
      <form onSubmit={this.handleTransfer}>
        <div className="c-form-row">
          <label>Receiver</label>
          <input type="text" placeholder="Receiver" name="toAddress" value={this.state.toAddress}
                 onChange={this.handleToAddressChange}/>
        </div>
        <div className="c-form-row">
          <label>Coins</label>
          <input type="number" placeholder="Coins" name="coins" value={this.state.coins}
                 onChange={this.handleCoinsChange}/>
        </div>
        <div className="c-form-row">
          <input type="submit" value="Send AsyncCoin"/>
        </div>
      </form>
    );
  }

  render () {
    return (
      <div className="c-component c-transfer-coins">
        <h2>Transfer coins</h2>
        {this.renderForm()}
      </div>
    );
  }
}

export default TransferCoins;



// WEBPACK FOOTER //
// ./src/components/CoinsPage/TransferCoins.js